
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/CouncilAnnouncement",
      function () {
        return require("private-next-pages/CouncilAnnouncement/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/CouncilAnnouncement"])
      });
    }
  